import layouts from "../../layout";
import EmpresaIndex from "../../views/apps/ncfmovil/EmpresasList.vue";
import BalanceReport from "@/views/apps/ncfmovil/Reports/SUPPLIER_BALANCE_REPORT.vue";
import TicketSearch from "../../views/apps/ncfmovil/Reports/TicketSearch.vue";
import TransactionReport from "@/views/apps/ncfmovil/TransactionReport.vue";
import TicketsReport from "@/views/apps/ncfmovil/TicketsReport.vue";
import CardBalanceReport from "@/views/apps/ncfmovil/CardBalanceReport.vue";
export default {
  path: "/ceo",
  name: "ceo",
  component: () =>
    import(/* webpackChunkName: "cmi" */ "@/views/apps/ncfmovil/CEO.vue"),
  meta: {
    auth: true,
    title: "CEO",
    tags: ["ceo"]
  },

  redirect: {
    name: "ceo-rpt-equipos"
  },

  children: [
    // Objectives
    {
      path: "rdl-equipos",
      name: "ceo-rpt-equipos",
      component: EmpresaIndex,
      meta: {
        auth: true,
        searchable: true,
        title: "Equipos",
        layout: layouts.navLeft,
        tags: ["E ncfmovil"],
        index: true
      }
    },
    {
      path: "balance-report",
      name: "ceo-balance-report",
      component: BalanceReport,
      meta: {
        auth: true,
        searchable: true,
        title: "Balance Report",
        layout: layouts.navLeft,
        tags: ["balance, suppliers"],
        index: true
      }
    },
    {
      path: "ticket-report",
      name: "ceo-ticket-report",
      component: TicketSearch,
      meta: {
        auth: true,
        searchable: true,
        title: "Ticket Report",
        layout: layouts.navLeft,
        tags: ["balance, suppliers"],
        index: true
      }
    },
    {
      path: "get-ticket-report",
      name: "ceo-ticket-generacion-report",
      component: TicketsReport,
      meta: {
        auth: true,
        searchable: true,
        title: "Ticket Report",
        layout: layouts.navLeft,
        tags: ["balance, suppliers"],
        index: true
      }
    },
    {
      path: "transaction-report",
      name: "ceo-transaction-report",
      component: TransactionReport,
      meta: {
        auth: true,
        searchable: true,
        title: "Transaction Report",
        layout: layouts.navLeft,
        tags: ["balance, suppliers"],
        index: true
      }
    },
    {
      path: "get-card-balance-report",
      name: "ceo-card-balance-report",
      component: CardBalanceReport,
      meta: {
        auth: true,
        searchable: true,
        title: "Card Balance Report",
        layout: layouts.navLeft,
        tags: ["balance, suppliers"],
        index: true
      }
    }
  ]
};
